import { log } from 'utils/error-logging';
import includeExternal from 'utils/include-external';
import locator from 'utils/locator';
import { isPaymentPath } from 'constants/payment-pages';
import { isRewardsPartner } from './isRewardsPartner';

/**
 * Check if Impact should be active (i.e. call identify/trackConversion functions).
 * This does NOT check includeExternal, so it works with stubbed window.ire in functional tests.
 *
 * Returns true if EITHER:
 * - It's a rewards partner (im_rewards=1 in URL or session storage) - "consent mode", OR
 * - The user has given marketing consent
 *
 * Note: irclickid is NOT required for Impact to load. It will be included in conversion
 * tracking if present, but conversions are sent regardless.
 *
 * Note that this function needs to work both server-side and client-side. For any
 * logic for the client-side only (i.e. checking sessionStorage), we need to check
 * `isInitialRender` - only execute client-side code when `isInitialRender` is false.
 */
export const shouldUseImpact = (hasMarketingConsent: boolean, isInitialRender: boolean) => {
  try {
    if (isPaymentPath(locator.pathname)) {
      return false;
    }

    if (hasMarketingConsent) {
      return true;
    }

    return isRewardsPartner(isInitialRender);
  } catch (exception) {
    log(exception, { logger: 'impact-loader' });
    return false;
  }
};

/**
 * Load the real Impact script...
 * IF `includeExternal` AND shouldUseImpact is true.
 */
export const shouldLoadImpact = (hasMarketingConsent: boolean, isInitialRender: boolean) =>
  includeExternal() && shouldUseImpact(hasMarketingConsent, isInitialRender);
